import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const mileageHeader = ({
  vendorId
}) => (
  <div className='row'>
    <div className='col-12'>
      <div
        className='bg-viagens radius-top row align-items-center px-1'
        data-mileage={vendorId}
      >
        <div className='col-12 px-3'>
          <h2 className='color-ui-white txt-title-2 txt-circular-book'>
            Transferência de pontos
          </h2>
        </div>
      </div>
    </div>
  </div>
)

mileageHeader.propTypes = {
  vendorId: PropTypes.string
}
const mapStateToProps = ({ oidc }) => {
  return ({ campaignId: oidc && oidc.user && oidc.user.profile['custom:campaign_id'] })
}
export default connect(mapStateToProps)(mileageHeader)



// WEBPACK FOOTER //
// ./src/features/MileageRescue/mileageHeader.js